import React from 'react';
import '../Styles/About.css';

const About = () => {
    return (
        <div className="about">
            <header>
                <h1>About Cyphr Systems</h1>
                <p>Innovating privacy-first digital experiences.</p>
            </header>
            <section className="about-section">
                <h2>Our Mission</h2>
                <p>
                    At Cyphr Systems, our mission is to provide a secure and private digital ecosystem
                    where users can freely connect, create, and communicate without compromising their data.
                </p>
            </section>
            <section className="about-section">
                <h2>Our Vision</h2>
                <p>
                    We envision a world where digital privacy is not a privilege but a fundamental right.
                    Our suite of apps is designed to empower users with tools that prioritize simplicity,
                    security, and transparency.
                </p>
            </section>
            <section className="about-section">
                <h2>What We Offer</h2>
                <ul>
                    <li>Private Expression with Cyphr Void</li>
                </ul>
            </section>
        </div>
    );
};

export default About;
